var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlugBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "vhzz2m9mla",
    d: "M16.8 4.28c0-.707-.573-1.28-1.28-1.28-.707 0-1.28.573-1.28 1.28v3.84h2.56V4.28zm1.92 3.12H4.64c-.353 0-.64.287-.64.64v1.28c0 .353.287.64.64.64h.64v1.28c0 3.041 2.14 5.663 5.12 6.272v3.968h2.56v-3.968c2.98-.61 5.12-3.23 5.12-6.272V9.96h.64c.353 0 .64-.287.64-.64V8.04c0-.353-.287-.64-.64-.64zm-9.6-3.12C9.12 3.573 8.547 3 7.84 3c-.707 0-1.28.573-1.28 1.28v3.84h2.56V4.28z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#37c0ca",
    fillRule: "nonzero",
    xlinkHref: "#vhzz2m9mla"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlugBlue);
export default __webpack_public_path__ + "static/media/icon-plug-blue.c34aa809cbe383a35727efe235a79ee1.svg";
export { ForwardRef as ReactComponent };